import module from '../shared.module';
import _ from 'lodash';

module.factory('FriendsService', [
  '$resource',
  '$q',
  'CurrentUserService',
  function ($resource, $q, CurrentUserService) {
    var FriendsResource = $resource('/api/friends');
    var cachedFriendList;
    var friendListDeferred;

    var returnVal = {
      getFriendById: function (id) {
        var deferred = $q.defer();

        if (id == CurrentUserService.currentUser.id) {
          deferred.resolve({
            id: id,
            name: CurrentUserService.currentUser.name,
          });
        } else {
          returnVal.friends.then(function (data) {
            var friend = _.find(data, { id: id });
            deferred.resolve(friend);
          });
        }

        return deferred.promise;
      },
      get friends() {
        if (friendListDeferred) {
          return friendListDeferred.promise;
        }

        friendListDeferred = $q.defer();
        if (cachedFriendList) {
          friendListDeferred.resolve(cachedFriendList);
        } else {
          FriendsResource.query().$promise.then(
            function (data) {
              // remove self
              _.remove(data, { id: CurrentUserService.currentUser.id });
              cachedFriendList = data;
              _.each(cachedFriendList, function (friend) {
                friend.name = friend.firstName;
                friend.sortName = friend.name;
                friend.icon = 'fa-user';
              });
              cachedFriendList.unshift({
                id: 0,
                sortName: '__Everyone',
                name: 'Everyone',
                icon: 'fa-users',
              });

              friendListDeferred.resolve(cachedFriendList);
            },
            function (err) {
              friendListDeferred.reject(err);
            }
          );
        }
        return friendListDeferred.promise;
      },
    };

    return returnVal;
  },
]);
